import a1 from "../../assets/a1.png";
import a2 from "../../assets/a2.png";
import a3 from "../../assets/a3.avif";
import w1 from "../../assets/w1.jpeg"
import w2 from "../../assets/w2.jpg"
import w3 from "../../assets/w3.jpg"

export const projectsData = [
    {
        id: 1,
        image: w1,
        title: "AI-Code-Reviewer",
        category: "Web",
        code: "https://github.com/AliHassan521/AI-Code-Reviewer"
    },
    {
        id: 2,
        image: w2,
        title: "Chat App",
        category: "Web",
        code: "https://github.com/AliHassan521/Chat-App"
    },
    {
        id: 3,
        image: w3,
        title: "Employee Management System",
        category: "Web",
        code: "https://github.com/AliHassan521/Employee-Management-System"
    },
    {
        id: 4,
        image: a1,
        title: "MLNGMS",
        category: "App",
        code: "https://github.com/AliHassan521/MLNGMS-Mobile_App"
    },
    {
        id: 5,
        image: a2,
        title: "UET Navigation App",
        category: "App",
        code: "https://github.com/AliHassan521/uet_app"
    },
    {
        id: 6,
        image: a3,
        title: "Voice Assistant App",
        category: "App",
        code: "https://github.com/AliHassan521/Voice_Assistance_App"
    },
];

export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "Web",
    },
    {
        name: "App",
    },
];